import {
    AF_H2H,
    AMERICAN_FOOTBALL_MODULE, BASEBALL, BASEBALL_MODULE,
    BASKET_BALL,
    BASKET_BALL_EURO,
    BASKET_BALL_NBA,
    BASKETBALL_MODULE,
    CITY_DOGS, CRICKET, CRICKET_MODULE,
    CYCLING,
    DOGS,
    FIRST_DOWN,
    FIRST_DOWN_MODULE,
    FOOTBALL,
    FOOTBALL_MODULE,
    HORSES,
    HORSES_SPRINTS,
    MARBLES,
    MATCHDAY,
    MATCHDAY_MODULE,
    MOTOR_RACING,
    NFL,
    NFLA,
    NUMBERS,
    RACING_MODULE,
    SOCCER3_FOOTBALL,
    SPEEDWAY,
    TENIS, TENNIS, TENNIS_MODULE,
    TROTTING
} from '../constants/identifiers';

export function getModuleFromEventType(eventType) {
    if (eventType !== undefined) {
        switch (eventType) {
            case HORSES:
            case HORSES_SPRINTS:
            case DOGS:
            case CITY_DOGS:
            case SPEEDWAY:
            case MOTOR_RACING:
            case NUMBERS:
            case TROTTING:
            case CYCLING:
            case MARBLES:
                return RACING_MODULE;
            case FOOTBALL:
            case SOCCER3_FOOTBALL:
                return FOOTBALL_MODULE;
            case BASKET_BALL:
            case BASKET_BALL_EURO:
            case BASKET_BALL_NBA:
                return BASKETBALL_MODULE;
            case NFLA:
            case AF_H2H:
            case NFL:
                return AMERICAN_FOOTBALL_MODULE;
            case FIRST_DOWN:
                return FIRST_DOWN_MODULE;
            case MATCHDAY:
                return MATCHDAY_MODULE;
            case TENIS:
            case CRICKET:
                return CRICKET_MODULE;
            case TENNIS:
                return TENNIS_MODULE;
            case BASEBALL:
                return BASEBALL_MODULE;
            default:
                return;
        }
    }
}

export function isSoccer3FootballEvent(eventType) {
    switch (eventType) {
        case SOCCER3_FOOTBALL:
            return true;
        default:
            return false;
    }
}

    export function isNFLEvent(eventtype){
        switch(eventtype){
            case NFL:
                return true;
            default:
                return false;
        }
    }

    export function isNBAEvent(eventType){
        switch(eventType){
            case BASKET_BALL_NBA:
                return true
            default:
                return false;
        }
    }



// WEBPACK FOOTER //
// ./src/helpers/moduleHelpers.js